module.exports = __webpack_public_path__ + "static/nwo-d2fd85d5181ef5181109095d30668fa3.jpg";